module.exports = __webpack_public_path__ + "static/media/vehicle-icon.c8286c10.svg";